import "bootstrap-filestyle";

const config = {
  buttonName: "btn-filestyle",
  iconName: "fa fa-folder-open",
  placeholder: "Keine Dateien",
  buttonText: "Datei auswählen"
};

function makeFileInputs() {
  let lang = document.documentElement.lang;
  if(lang === 'cs-CZ') {
    config.placeholder = "Žádný soubor";
    config.buttonText = "Výběr souboru";
  } else if(lang === "en-GB") {
    config.placeholder = "No file";
    config.buttonText = "Select file";
  }
  $(":file").filestyle(config);
}

$(document).ready(function() {
  makeFileInputs();
});
